import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { EmptyStateRow, TableLoader, useStyles } from 'features/command-center/components';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { replaceQueryParams } from 'features/command-center/utils';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { UIStatus } from 'UI/constants/status';

import { TEAM_COLUMN_NAME } from '../../productionBoard.constants';
import { formatTransactionByWeekResponse } from '../../productionBoard.utils';

export const ProductionTransactionByWeek = ({ columns, recruiters, queryParams }) => {
  const classes = useStyles();
  const updatedQueryParams = replaceQueryParams({
    queryParams,
    keyParam: 'recruiters',
    valueParam: recruiters
  });
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionTransactions}?${updatedQueryParams}`;

  const { state } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT
  });

  const formattedTransactions = formatTransactionByWeekResponse(state?.results);

  if (state.status === UIStatus.Loading) return <TableLoader colSpan={columns.length} />;

  if (!formattedTransactions) return <EmptyStateRow colSpan={columns.length} />;

  return formattedTransactions.map(row => (
    <TableRow key={row.id} hover>
      <TableCell />

      {columns.map(col => {
        if (col.options.display !== true) return null;

        const isNameColumn = col.name === TEAM_COLUMN_NAME;

        return (
          <TableCell
            key={col.name}
            className={isNameColumn ? classes.additionalLeftPadding : null}
            align={isNameColumn ? 'left' : 'right'}
          >
            <span className={classes.lightWeightRow}>
              {col?.options?.customBodyRender
                ? col.options.customBodyRender(row[col.name])
                : row[col.name]}
            </span>
          </TableCell>
        );
      })}
    </TableRow>
  ));
};
